var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-923.949 -325)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(923.949 325)",
    fill: "#fff",
    stroke: "#5fb527",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 20.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(932.765 333.641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1588.111,570.166h0a1.612,1.612,0,0,1-1.611-1.611v-6.444a1.612,1.612,0,0,1,1.611-1.611h0a1.612,1.612,0,0,1,1.611,1.611v6.444A1.612,1.612,0,0,1,1588.111,570.166Z",
    transform: "translate(-1584.352 -551.908)",
    fill: "#d3d3d3",
    stroke: "#02022c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1586.648,567.813a2.686,2.686,0,0,1,0-5.263",
    transform: "translate(-1584.5 -551.756)",
    fill: "none",
    stroke: "#02022c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1604.111,560.5h0a1.612,1.612,0,0,1,1.611,1.611v6.444a1.612,1.612,0,0,1-1.611,1.611h0a1.612,1.612,0,0,1-1.611-1.611v-6.444A1.612,1.612,0,0,1,1604.111,560.5Z",
    transform: "translate(-1583.168 -551.908)",
    fill: "#d3d3d3",
    stroke: "#02022c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.5,562.55a2.686,2.686,0,0,1,0,5.263",
    transform: "translate(-1582.945 -551.756)",
    fill: "none",
    stroke: "#02022c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.8,575.648h-3.222a1.074,1.074,0,0,1-1.074-1.074h0a1.074,1.074,0,0,1,1.074-1.074h3.222a1.074,1.074,0,0,1,1.074,1.074h0A1.074,1.074,0,0,1,1596.8,575.648Z",
    transform: "translate(-1583.908 -550.946)",
    fill: "none",
    stroke: "#02022c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.018,569.5c0,4.3-2.148,5.37-7.519,5.37",
    transform: "translate(-1583.537 -551.242)",
    fill: "none",
    stroke: "#02022c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1588.5,561.092v-.537a8.055,8.055,0,0,1,8.055-8.055h0a8.055,8.055,0,0,1,8.055,8.055v.537",
    transform: "translate(-1584.204 -552.5)",
    fill: "none",
    stroke: "#02022c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.ae9abdc384dd676051fe1bc86bf6de6e.svg";
export { ForwardRef as ReactComponent };